import { render, staticRenderFns } from "./personRole.vue?vue&type=template&id=fe372676&"
import script from "./personRole.vue?vue&type=script&lang=js&"
export * from "./personRole.vue?vue&type=script&lang=js&"
import style0 from "./personRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "personRole.vue"
export default component.exports